// extracted by mini-css-extract-plugin
module.exports = {"textInput":"EditCompany_textInput__3BpUd","logo":"EditCompany_logo__Rl1q5","activeCheckbox":"EditCompany_activeCheckbox__2VPhU"};